export default __webpack_public_path__ + "static/media/logo.fda66d7e.png";